/* WP cart drawer — fast, theme-styled replacement for Kaching Cart's drawer.
   - Opens instantly when anything is added to the cart (Dawn form, Kaching Bundles, quick adds), then fills in from /cart.js.
   - Groups Kaching bundle lines (main kit + bundle tools + checkbox upsells) under the kit.
   - Progress bar for the Buy 2 / Buy 3 offer (tiers from Theme settings > WP Promo); the discount itself is applied
     server-side (Kaching Cart's order discount "KCART - 10%", or Shopify automatic discounts on the kit collections
     titled like "Buy 2 kits · 10% off"), so totals always come from /cart.js.
   Config: window.wpCartConfig (snippets/wp-cart.liquid). */
(() => {
  const C = window.wpCartConfig;
  if (!C || window.wpCart) return;

  // ----- activation (test mode only with ?cart=wp) -----
  try {
    const q = new URLSearchParams(location.search).get('cart');
    if (q === 'wp') sessionStorage.setItem('wpcart', '1');
    if (q === 'off') sessionStorage.removeItem('wpcart');
  } catch (e) { /* storage blocked */ }
  let testOn = false;
  try { testOn = sessionStorage.getItem('wpcart') === '1'; } catch (e) { /* ignore */ }
  if (C.mode !== 'on' && !(C.mode === 'test' && testOn)) return;
  document.documentElement.classList.add('wpc-active');

  const money = (cents) => new Intl.NumberFormat(C.locale || 'en', { style: 'currency', currency: C.currency || 'USD' }).format((cents || 0) / 100);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const img = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  const nativeFetch = window.fetch.bind(window); // our own calls skip the add-to-cart hook below
  const tiers = String(C.tiers || '').split(',').map((t) => t.split(':').map(Number)).filter((t) => t[0] > 0 && t[1] > 0).sort((a, b) => a[0] - b[0]);
  // multi-kit discount titles: Kaching Cart ("KCART - 10%") or Shopify automatic discounts ("Buy 2 kits · 10% off", "Buy_3_15%_OFF")
  const MULTI = /^(KCART|Buy[\s_-]*\d)/i;
  const isMulti = (d) => MULTI.test((d && d.title) || '');
  const kaching = (item) => { try { return JSON.parse(item.properties && item.properties.__kaching_bundles); } catch (e) { return null; } };

  // ----- markup -----
  const root = document.createElement('div');
  root.className = 'wpcart';
  root.innerHTML = `
    <div class="wpc__overlay" data-wpc-close></div>
    <aside class="wpc__panel" role="dialog" aria-modal="true" aria-label="Your cart" tabindex="-1">
      <header class="wpc__head">
        <p class="wpc__title">Your cart <span data-wpc-count></span></p>
        <button type="button" class="wpc__x" data-wpc-close aria-label="Close cart">&times;</button>
      </header>
      <div class="wpc__progress" data-wpc-progress hidden></div>
      <div class="wpc__loading" data-wpc-loading hidden><span></span></div>
      <div class="wpc__body" data-wpc-body></div>
      <footer class="wpc__foot" data-wpc-foot hidden></footer>
      <div class="wpc__shade" data-wpc-sheet-close></div>
      <div class="wpc__sheet" data-wpc-sheet role="dialog" aria-modal="true" aria-labelledby="wpc-sheet-title">
        <div class="wpc__sheet-head"><p class="wpc__sheet-title" id="wpc-sheet-title">Your offers</p><button type="button" class="wpc__sheet-x" data-wpc-sheet-close aria-label="Close offers">&times;</button></div>
        <div class="wpc__sheet-body" data-wpc-sheet-body></div>
        <div class="wpc__sheet-foot"><button type="button" class="wpc__sheet-done" data-wpc-sheet-close>Done</button></div>
      </div>
    </aside>`;
  document.body.appendChild(root);
  const $ = (s) => root.querySelector(s);
  let cart = null, lastFocus = null, recoFor = null, recos = [];
  let lastAdd = 0, lastClose = 0; // to ignore Kaching's late "open" signals
  let adding = 0; // adds still on their way: an empty cart shows the loading skeleton, not the empty-cart suggestions
  const skeleton = '<div class="wpc__skeleton"><i></i><i></i><i></i></div>';
  const isAdding = () => adding > 0 && Date.now() - lastAdd < 15000; // an add that never answers can't hide the cart for long
  const added = () => { adding = Math.max(0, adding - 1); setTimeout(() => refresh(true), 60); };

  const open = (loading) => {
    if (!root.classList.contains('is-open')) lastFocus = document.activeElement;
    root.classList.add('is-open');
    document.documentElement.classList.add('wpc-open');
    $('[data-wpc-loading]').hidden = !loading;
    if (!cart || (isAdding() && !cart.item_count)) $('[data-wpc-body]').innerHTML = skeleton;
    else if (!cart.item_count) loadFavs();
    setTimeout(() => $('.wpc__panel').focus(), 50);
  };
  const close = () => {
    if (OFF) closeSheet(false);
    lastClose = Date.now();
    root.classList.remove('is-open');
    document.documentElement.classList.remove('wpc-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  // ----- data -----
  const fetchCart = () => nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const refresh = async (showLoading) => {
    if (showLoading) $('[data-wpc-loading]').hidden = false;
    try {
      cart = await fetchCart();
      render();
      loadRecos();
    } catch (e) {
      // network hiccup: never leave the drawer stuck on the loading skeleton
      if (!cart) $('[data-wpc-body]').innerHTML = `<div class="wpc__empty"><p>We couldn't load your cart.</p><a href="${esc(C.cartUrl)}" class="wpc__empty-all">Open the cart page &rarr;</a></div>`;
    } finally {
      $('[data-wpc-loading]').hidden = true;
    }
  };
  const change = async (updates) => {
    $('[data-wpc-loading]').hidden = false;
    root.classList.add('is-busy');
    try {
      cart = await nativeFetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      }).then((r) => r.json());
      cart = await fetchCart(); // fresh discounts after the change
      render();
    } catch (e) {
      refresh(false); // show what the cart really holds
    } finally {
      root.classList.remove('is-busy');
      $('[data-wpc-loading]').hidden = true;
    }
  };

  // ----- grouping: kit + its bundle items + its checkbox upsells -----
  const groups = () => {
    const out = [], byId = {};
    cart.items.forEach((it) => {
      const k = kaching(it);
      if (k && k.id) {
        let g = byId[k.id];
        if (!g) { g = byId[k.id] = { main: null, bundle: [], addons: [] }; out.push(g); }
        if (k.main) g.main = it; else if (k.checkboxUpsell) g.addons.push(it); else g.bundle.push(it);
      } else {
        out.push({ main: it, bundle: [], addons: [] });
      }
    });
    // a group whose main line was removed: promote the first item
    out.forEach((g) => { if (!g.main) g.main = g.bundle.shift() || g.addons.shift(); });
    return out;
  };
  const kitCount = () => cart.items.reduce((n, it) => {
    const k = kaching(it);
    const child = k && !k.main && !k.checkboxUpsell; // tools inside a bundle are not kits
    return n + (C.kitTypes.includes(it.product_type) && !child ? it.quantity : 0);
  }, 0);

  const priceHtml = (it) => it.original_line_price > it.final_line_price
    ? `<s>${money(it.original_line_price)}</s> <b>${money(it.final_line_price)}</b>`
    : `<b>${money(it.final_line_price)}</b>`;

  const lineHtml = (g) => {
    const it = g.main;
    const keys = [it, ...g.bundle, ...g.addons].map((x) => x.key);
    const bundleName = ((it.line_level_discount_allocations || []).find((a) => !isMulti(a.discount_application)) || {}).discount_application;
    const name = bundleName && g.bundle.length ? bundleName.title : '';
    const sub = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title.replace(/"/g, '″') : '';
    const props = Object.entries(it.properties || {}).filter(([k, v]) => k[0] !== '_' && v && !/^__/.test(k));
    const groupTotal = [it, ...g.bundle].reduce((s, x) => s + x.final_line_price, 0);
    const groupOrig = [it, ...g.bundle].reduce((s, x) => s + x.original_line_price, 0);
    const child = (x, removable) => `
      <li class="wpc__sub">
        <span class="wpc__sub-img">${x.image ? `<img src="${esc(img(x.image, 80))}" alt="" loading="lazy">` : ''}</span>
        <span class="wpc__sub-name">${x.quantity > 1 ? x.quantity + ' × ' : ''}${esc(x.product_title.split('|')[0].trim())}</span>
        <span class="wpc__sub-price">${priceHtml(x)}</span>
        ${removable ? `<button type="button" class="wpc__sub-x" data-wpc-remove="${esc(x.key)}" aria-label="Remove ${esc(x.product_title)}">&times;</button>` : ''}
      </li>`;
    return `
      <li class="wpc__item">
        <a class="wpc__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(img(it.image, 200))}" alt="${esc(it.product_title)}" loading="lazy">` : ''}</a>
        <div class="wpc__info">
          <a class="wpc__name" href="${esc(it.url)}">${esc(it.product_title.split('|')[0].trim())}</a>
          ${sub ? `<p class="wpc__variant">${esc(sub)}</p>` : ''}
          ${props.map(([k, v]) => `<p class="wpc__variant">${esc(k)}: ${esc(v)}</p>`).join('')}
          ${name ? `<p class="wpc__bundle">${esc(name)}</p>` : ''}
          <div class="wpc__row">
            <div class="wpc__qty" role="group" aria-label="Quantity">
              <button type="button" data-wpc-qty="${esc(it.key)}" data-step="-1" aria-label="Decrease">−</button>
              <span>${it.quantity}</span>
              <button type="button" data-wpc-qty="${esc(it.key)}" data-step="1" aria-label="Increase"${g.bundle.length ? ' disabled title="Bundle quantity is set on the product page"' : ''}>+</button>
            </div>
            <span class="wpc__price">${groupOrig > groupTotal ? `<s>${money(groupOrig)}</s> ` : ''}<b>${money(groupTotal)}</b></span>
          </div>
          <button type="button" class="wpc__remove" data-wpc-remove="${esc(keys.join(','))}">Remove</button>
        </div>
        ${g.bundle.length ? `<ul class="wpc__subs" role="list"><li class="wpc__subs-label">Included in your kit</li>${g.bundle.map((x) => child(x, false)).join('')}</ul>` : ''}
        ${g.addons.length ? `<ul class="wpc__subs wpc__subs--addons" role="list"><li class="wpc__subs-label">Add-ons</li>${g.addons.map((x) => child(x, true)).join('')}</ul>` : ''}
      </li>`;
  };

  // progress follows the number of kits in the cart (PBN / diamond kits, not tools or bundle extras)
  const progressHtml = () => {
    if (!C.promoOn || !tiers.length) return '';
    const top = tiers[tiers.length - 1];
    const n = kitCount();
    const reached = tiers.filter((t) => n >= t[0]).pop();
    const next = tiers.find((t) => n < t[0]);
    let msg;
    const os = OFF && offerState();
    if (os && !os.autoSave && os.live.some((c) => c.amount)) {
      // a code is used instead of the kit discount: only point at a tier that would beat it
      if (!os.next) return '';
      const more = os.next[0] - n;
      msg = `Add <b>${more} more kit${more > 1 ? 's' : ''}</b> to save <b>${os.next[1]}%</b>`;
    } else if (!next) msg = `You're saving <b>${top[1]}%</b> on your kits 🎉`;
    else {
      const more = next[0] - n;
      const add = `Add <b>${more} more kit${more > 1 ? 's' : ''}</b> to save <b>${next[1]}%</b>`;
      msg = reached ? `<b>${reached[1]}% off</b> your kits. ${add}` : add;
    }
    const fill = Math.min(100, (n / top[0]) * 100);
    const marks = tiers.map((t) => `<span class="wpc__mark${n >= t[0] ? ' is-done' : ''}" style="left:${(t[0] / top[0]) * 100}%"><i>${t[1]}%<small>${t[0]} kits</small></i></span>`).join('');
    return `<p>${msg}</p><div class="wpc__bar"><span style="width:${fill}%"></span>${marks}</div>`;
  };

  const footHtml = () => {
    const saved = cart.original_total_price - cart.total_price;
    if (OFF) {
      // offers panel: one row for every discount, then the checkout button with the old and new total
      const s = offerState();
      const ship = s.codes.find((c) => c.ship && c.ok);
      return `
        ${offersRowHtml(s)}
        <a class="wpc__checkout wpc__checkout--split" href="${esc(C.checkoutUrl)}"><span>Checkout</span><span class="wpc__ck-p">${saved > 0 ? `<s>${money(cart.original_total_price)}</s> ` : ''}${money(cart.total_price)}</span></a>
        <p class="wpc__fine">${ship ? `Shipping code ${esc(ship.code)} applies at checkout` : 'Shipping &amp; taxes calculated at checkout'}</p>`;
    }
    // every discount by name: multi-kit, sale / automatic discounts, codes (bundle discounts show on their kit)
    const named = {};
    const addNamed = (title, amount) => { if (!amount) return; named[title] = (named[title] || 0) + amount; };
    // Kaching bundle discounts ("The Professional Kit") already show on their kit: skip the titles used on bundle lines
    const bundleTitles = new Set();
    cart.items.forEach((it) => { const k = kaching(it); if (k && !k.main) (it.line_level_discount_allocations || []).forEach((a) => bundleTitles.add(a.discount_application.title)); });
    cart.items.forEach((it) => (it.line_level_discount_allocations || []).forEach((a) => {
      const t = a.discount_application.title || 'Discount';
      if (isMulti(a.discount_application) || !bundleTitles.has(t)) addNamed(t, a.amount);
    }));
    (cart.cart_level_discount_applications || []).forEach((d) => addNamed(d.title || 'Discount', d.total_allocated_amount));
    // the multi-kit discount is not listed (it's in "You save"); other discounts (codes, sales) keep their name
    const cartLevel = Object.entries(named).filter(([title]) => !isMulti({ title }))
      .map(([title, amount]) => `<p class="wpc__line wpc__line--disc"><span>${esc(title)}</span><span>−${money(amount)}</span></p>`).join('');
    return `
      ${cartLevel}
      ${saved > 0 ? `<p class="wpc__line wpc__line--save"><span>You save</span><span>${money(saved)}</span></p>` : ''}
      <p class="wpc__line wpc__line--total"><span>Total</span><span>${money(cart.total_price)}</span></p>
      <p class="wpc__mini">${saved > 0 ? `<span class="wpc__mini-save">You save ${money(saved)}</span>` : ''}<span>Taxes &amp; shipping at checkout</span></p>
      <a class="wpc__checkout" href="${esc(C.checkoutUrl)}">Checkout · ${money(cart.total_price)}</a>
      <p class="wpc__note">Shipping and taxes calculated at checkout. Secured shipping on every order.</p>`;
  };

  // ----- offers panel (Theme settings > WP Cart > Cart offers): the codes the store chose to show, one tap to apply -----
  // Shopify decides what applies: a code that doesn't combine with the Buy 2/3/4 discount only wins when it saves more
  // (a tie keeps the kit discount), and a code that stops applying stays in the cart as "not applicable". The panel only
  // estimates to sort and label the list; amounts shown as applied always come from /cart.js.
  const OFF = (() => {
    const o = C.offers || {};
    let on = o.mode === 'on';
    try {
      const q = new URLSearchParams(location.search).get('offers');
      if (q === '1') sessionStorage.setItem('wpoffers', '1');
      if (q === '0') sessionStorage.removeItem('wpoffers');
      if (o.mode === 'test' && sessionStorage.getItem('wpoffers') === '1') on = true;
    } catch (e) { /* storage blocked */ }
    if (!on) return null;
    // one code per line: CODE | Name | Note | min kits | stack
    const list = String(o.codes || '').split(/\r?\n/).map((l) => l.split('|').map((s) => s.trim()))
      .filter((p) => p[0] && p[0][0] !== '#')
      .map(([code, name, note, min, stack]) => {
        const label = name || code;
        const pct = (label.match(/(\d+(?:\.\d+)?)\s*%/) || [])[1];
        const amt = (label.match(/\$\s*(\d+(?:\.\d+)?)/) || [])[1];
        return {
          code: code.toUpperCase(), name: label, note: note || '', min: parseInt(min, 10) || 0,
          stack: /^(y|yes|stack|true|1)$/i.test(stack || ''), ship: /ship/i.test(label),
          pct: pct ? Number(pct) : 0, amt: amt ? Math.round(Number(amt) * 100) : 0,
        };
      });
    return { list, open: false, msg: null, typed: '' };
  })();
  const offerOf = (code) => OFF.list.find((x) => x.code === code);
  const tagIcon = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9z"/><circle cx="8" cy="8" r="1.6"/></svg>';

  const offerState = () => {
    const saved = {}, others = {}; // others: automatic discounts that aren't Buy N (Kaching bundle "The Professional Kit", popups)
    let autoSave = 0, autoTitle = '';
    const take = (d, amount) => {
      if (!amount) return;
      if (isMulti(d)) { autoSave += amount; autoTitle = d.title; return; }
      const into = d.type === 'discount_code' ? saved : others;
      const k = d.type === 'discount_code' ? String(d.title || '').toUpperCase() : d.title || 'Discount';
      into[k] = (into[k] || 0) + amount;
    };
    cart.items.forEach((it) => (it.line_level_discount_allocations || []).forEach((a) => take(a.discount_application, a.amount)));
    (cart.cart_level_discount_applications || []).forEach((d) => take(d, d.total_allocated_amount));
    const otherSave = Object.values(others).reduce((a, b) => a + b, 0);
    const n = kitCount();
    const kitSub = cart.items.reduce((s, it) => {
      const k = kaching(it);
      return s + (C.kitTypes.includes(it.product_type) && !(k && !k.main && !k.checkboxUpsell) ? it.original_line_price : 0);
    }, 0);
    const reached = tiers.filter((t) => n >= t[0]).pop();
    const m = String(autoTitle).match(/(\d+)\D+?(\d+)\s*%/);
    const autoName = m ? `Buy ${m[1]} kits · ${m[2]}% off` : reached ? `Buy ${reached[0]} kits · ${reached[1]}% off` : 'Kit discount';
    const codes = (cart.discount_codes || []).map((d) => {
      const code = String(d.code).toUpperCase(), o = offerOf(code), amount = saved[code] || 0;
      return { code, ok: !!d.applicable || !!(o && o.ship), amount, o, ship: !!(o && o.ship) }; // shipping codes: confirmed at checkout
    });
    const live = codes.filter((c) => c.ok);
    // what a code has to beat: every discount in the cart (codes that don't combine replace all of them)
    const cur = autoSave + otherSave + live.reduce((s, c) => s + c.amount, 0);
    const inCart = new Set(codes.map((c) => c.code));
    const subtotal = cart.original_total_price;
    const deals = OFF.list.filter((o) => !o.ship && !inCart.has(o.code)).map((o) => {
      const base = /kit/i.test(o.name) ? kitSub : subtotal; // "% off your kits": tools and add-ons don't count
      const est = o.pct ? Math.round((base * o.pct) / 100) : Math.min(o.amt, base);
      const total = est + (o.stack ? autoSave + otherSave : 0);
      let state = 'ok';
      if (n < o.min) state = 'locked';
      else if (est && cur && total <= cur + Math.max(1, cur * 0.01)) state = Math.abs(total - cur) <= Math.max(1, cur * 0.01) ? 'same' : 'less'; // a tie keeps the kit discount
      return { o, est, total, state };
    });
    const best = deals.filter((d) => d.state === 'ok' && d.est).sort((a, b) => b.total - a.total)[0];
    const ships = OFF.list.filter((o) => o.ship && !inCart.has(o.code));
    // a code already beating the kit discount: only tiers that would save more are worth offering
    const codePct = autoSave ? 0 : (live.reduce((m, c) => m + c.amount, 0) / Math.max(1, subtotal)) * 100;
    const ups = C.promoOn ? tiers.filter((t) => t[0] > n && t[1] > codePct + 0.5) : [];
    return { n, kitSub, reached, autoSave, autoName, others, codes, live, cur, deals, best, ships, ups, next: ups[0] };
  };

  const offersRowHtml = (s) => {
    const applied = [];
    if (s.autoSave) applied.push(s.autoName);
    Object.keys(s.others).forEach((t) => applied.push(t));
    s.live.forEach((c) => applied.push(c.o ? c.o.name : c.code));
    const avail = s.deals.filter((d) => d.state === 'ok').length + s.ships.length + (s.next ? 1 : 0);
    let t;
    if (applied.length > 1) t = `<b>${applied.length} offers applied</b><span>${esc(applied.join(' + '))}</span>`;
    else if (applied.length) t = `<b>${esc(applied[0])}</b> applied<span>${avail ? `${avail} more offer${avail > 1 ? 's' : ''} inside` : 'Tap to see your offers'}</span>`;
    else if (avail) t = `<b>${avail} offer${avail > 1 ? 's' : ''} available</b><span>Tap to pick the best one</span>`;
    else t = '<b>Have a discount code?</b><span>Tap to add it</span>';
    return `<button type="button" class="wpc__offers" data-wpc-offers aria-haspopup="dialog">${tagIcon}<span class="wpc__offers-t">${t}</span>${s.cur ? `<span class="wpc__offers-v">−${money(s.cur)}</span>` : ''}<span class="wpc__offers-chev" aria-hidden="true">›</span></button>`;
  };

  const offerCard = ({ cls = '', ic, icCls, name, code, side = '<span></span>', desc, tag, extra = '' }) => `
    <div class="wpc__oc ${cls}">${tag ? `<span class="wpc__oc-tag">${tag}</span>` : ''}
      <span class="wpc__oc-ic wpc__oc-ic--${icCls}">${ic}</span>
      <span class="wpc__oc-nm">${esc(name)}${code ? `<code>${esc(code)}</code>` : ''}</span>${side}
      <span class="wpc__oc-ds">${desc}</span>${extra}
    </div>`;

  const sheetHtml = (s) => {
    let h = '';
    const remove = (code) => `<button type="button" class="wpc__oc-btn wpc__oc-btn--link" data-wpc-offer-remove="${esc(code)}">Remove</button>`;
    // applied: the kit discount, codes in use, codes in the cart that aren't used right now
    const cards = [];
    if (s.autoSave) cards.push(offerCard({ cls: 'is-on', ic: '✓', icCls: 'auto', name: s.autoName, side: `<span class="wpc__oc-amt">−${money(s.autoSave)}</span>`, desc: 'Applied automatically' }));
    Object.entries(s.others).forEach(([title, amount]) => cards.push(offerCard({ cls: 'is-on', ic: '✓', icCls: 'auto', name: title, side: `<span class="wpc__oc-amt">−${money(amount)}</span>`, desc: 'Already in your item prices' })));
    s.codes.forEach((c) => {
      const name = c.o ? c.o.name : 'Your discount code';
      if (!c.ok) {
        const why = s.cur ? 'Not used: your current offer saves more. Codes don’t stack with your current discounts.' : 'Can’t be used with the items in your cart.';
        cards.push(offerCard({ cls: 'is-dim', ic: '%', icCls: 'code', name, code: c.code, side: remove(c.code), desc: why }));
      } else if (c.amount) {
        cards.push(offerCard({ cls: 'is-on', ic: '%', icCls: 'code', name, code: c.code, side: `<span class="wpc__oc-amt">−${money(c.amount)}</span>`, desc: 'Applied at checkout too', extra: remove(c.code) }));
      } else {
        cards.push(offerCard({ cls: 'is-on', ic: c.ship ? '🚚' : '%', icCls: 'code', name, code: c.code, side: remove(c.code), desc: c.ship ? 'Applied at checkout, where shipping is calculated' : 'Applied at checkout' }));
      }
    });
    if (cards.length) {
      const nOn = cards.length - s.codes.filter((c) => !c.ok).length;
      h += `<div class="wpc__og"><h3>Applied${nOn > 1 ? ` · ${nOn} offers` : ''}</h3>${cards.join('')}`;
      // a code beat the kit discount: say so, so nobody thinks the Buy 2 deal was lost
      const won = s.live.find((c) => c.amount);
      if (won && !s.autoSave && s.reached && C.promoOn) {
        const est = Math.round((s.kitSub * s.reached[1]) / 100);
        h += `<p class="wpc__oswap">Using <b>${esc(won.code)}</b> instead of <b>Buy ${s.reached[0]} kits · ${s.reached[1]}% off</b>${won.amount > est ? `, it saves ${money(won.amount - est)} more` : ''}. Codes and the kit discount don’t stack.</p>`;
      }
      h += '</div>';
    }
    // unlock more: the next Buy N tiers
    const { ups } = s;
    if (ups.length) {
      const each = s.n ? s.kitSub / s.n : 0;
      h += '<div class="wpc__og"><h3>Unlock more</h3>';
      ups.forEach((t, i) => {
        const more = t[0] - s.n;
        const word = s.n ? `Add ${more} more kit${more > 1 ? 's' : ''}` : `Add ${more} kits`;
        const total = each ? Math.round((each * t[0] * t[1]) / 100) : 0;
        h += offerCard({
          ic: `${t[1]}%`, icCls: 'lock', name: `Buy ${t[0]} kits · ${t[1]}% off`,
          side: i === 0 ? '<button type="button" class="wpc__oc-btn" data-wpc-addkit>Add a kit</button>' : '<span></span>',
          desc: `${word}${total ? ` · about ${money(total)} off ${t[0]} kits` : ''}`,
          extra: `<span class="wpc__oc-bar"><i style="width:${Math.min(100, (s.n / t[0]) * 100)}%"></i></span>`,
        });
      });
      h += '</div>';
    }
    // shipping codes (one at a time)
    if (s.ships.length && !s.codes.some((c) => c.ship && c.ok)) {
      h += `<div class="wpc__og"><h3>Shipping</h3>${s.ships.map((o) => offerCard({
        ic: '🚚', icCls: 'code', name: o.name, code: o.code,
        side: `<button type="button" class="wpc__oc-btn wpc__oc-btn--solid" data-wpc-offer-apply="${esc(o.code)}">Apply</button>`,
        desc: esc(o.note || 'Applied at checkout') + (o.stack && s.autoSave ? `, keeps your ${esc(s.autoName)}` : ''),
      })).join('')}</div>`;
    }
    // discount codes: pick one
    h += `<div class="wpc__og"><h3>${s.deals.length ? 'Discount codes · pick one' : 'Discount code'}</h3>`;
    s.deals.forEach((d) => {
      const { o } = d;
      if (d.state === 'locked') {
        const more = o.min - s.n;
        h += offerCard({ cls: 'is-dim', ic: '%', icCls: 'code', name: o.name, code: o.code, desc: `Add ${more} more kit${more > 1 ? 's' : ''} to use this code` });
      } else if (d.state !== 'ok') {
        h += offerCard({ cls: 'is-dim', ic: '%', icCls: 'code', name: o.name, code: o.code, desc: `${d.state === 'same' ? 'Same as your current deal' : 'Your current deal saves more'}.${o.stack ? '' : ' Codes don’t stack with your current discounts.'}` });
      } else {
        const more = d.est && s.cur ? d.total - s.cur : 0;
        const desc = [o.note && esc(o.note), d.est ? `About ${money(d.est)} off${more > 0 ? `, ${money(more)} more than now` : ''}` : ''].filter(Boolean).join(' · ') || 'Applied at checkout too';
        h += offerCard({
          ic: '%', icCls: 'code', name: o.name, code: o.code, tag: s.best === d ? 'Best deal' : '',
          side: `<button type="button" class="wpc__oc-btn wpc__oc-btn--solid" data-wpc-offer-apply="${esc(o.code)}">Apply</button>`, desc,
        });
      }
    });
    const msg = OFF.msg;
    h += `<form class="wpc__oenter" data-wpc-code-form><input name="code" value="${esc(OFF.typed)}" placeholder="Have a code?" aria-label="Discount code" autocomplete="off" autocapitalize="characters" spellcheck="false"><button type="submit" class="wpc__oc-btn wpc__oc-btn--solid">Apply</button></form>
      ${msg ? `<p class="wpc__omsg${msg.err ? ' is-err' : ''}" role="${msg.err ? 'alert' : 'status'}">${esc(msg.text)}</p>` : ''}</div>`;
    return h;
  };

  const renderSheet = () => {
    const el = $('[data-wpc-sheet-body]');
    if (!OFF || !el || !cart || !cart.item_count) return;
    const typing = document.activeElement && document.activeElement.name === 'code' && el.contains(document.activeElement);
    if (typing) OFF.typed = document.activeElement.value;
    el.innerHTML = sheetHtml(offerState());
    if (typing) { const i = el.querySelector('input[name="code"]'); i.focus(); i.setSelectionRange(i.value.length, i.value.length); }
    const m = el.querySelector('.wpc__omsg');
    if (m) m.scrollIntoView({ block: 'nearest' });
  };
  const openSheet = () => {
    OFF.open = true;
    renderSheet();
    root.classList.add('is-offers');
    setTimeout(() => { const b = $('[data-wpc-sheet] .wpc__sheet-x'); if (b) b.focus(); }, 50);
  };
  const closeSheet = (back) => {
    if (!OFF || !OFF.open) return;
    OFF.open = false;
    OFF.msg = null;
    root.classList.remove('is-offers');
    const b = $('[data-wpc-offers]');
    if (back !== false && b) b.focus();
  };

  // codes go straight into the cart (they carry over to checkout); Shopify answers which ones apply
  const setCodes = async (next, added) => {
    const before = new Set((cart.discount_codes || []).filter((d) => d.applicable).map((d) => String(d.code).toUpperCase()));
    const post = (codes) => nativeFetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: [...new Set(codes)].join(',') }),
    }).then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); });
    $('[data-wpc-loading]').hidden = false;
    root.classList.add('is-busy');
    try {
      await post(next);
      cart = await fetchCart();
      if (added) {
        const now = cart.discount_codes || [];
        const mine = now.find((d) => String(d.code).toUpperCase() === added);
        const listed = offerOf(added);
        if (mine && !mine.applicable && listed && listed.ship) {
          // shipping is only priced at checkout: the cart can't confirm a shipping code yet, so it stays
          OFF.msg = { err: false, text: `${added} saved. Free shipping shows at checkout.` };
          OFF.typed = '';
        } else if (!mine || !mine.applicable) {
          // keep the cart clean: drop the code that didn't apply, keep whatever the customer had
          await post(now.filter((d) => String(d.code).toUpperCase() !== added).map((d) => d.code));
          cart = await fetchCart();
          OFF.msg = { err: true, text: listed
            ? `${added} doesn't beat the discounts already in your cart, so we kept them. Codes don't stack with them.`
            : `We couldn't use ${added} on this cart. It may be misspelled or expired, or your current offer already saves more.` };
        } else {
          // a code it replaced (didn't combine) leaves the cart too
          const lost = now.filter((d) => !d.applicable && before.has(String(d.code).toUpperCase()));
          if (lost.length) { await post(now.filter((d) => d.applicable).map((d) => d.code)); cart = await fetchCart(); }
          OFF.msg = { err: false, text: `${added} applied.` };
          OFF.typed = '';
        }
      } else OFF.msg = null;
      render();
    } catch (e) {
      OFF.msg = { err: true, text: 'We couldn’t update your codes. Please try again.' };
      refresh(false);
    } finally {
      root.classList.remove('is-busy');
      $('[data-wpc-loading]').hidden = true;
    }
  };
  const applyCode = (raw) => {
    const code = String(raw || '').trim().toUpperCase();
    if (!code) { OFF.msg = { err: true, text: 'Enter a code first.' }; renderSheet(); return; }
    const current = (cart.discount_codes || []).map((d) => String(d.code).toUpperCase());
    if (current.includes(code)) { OFF.msg = { err: false, text: `${code} is already in your cart.` }; renderSheet(); return; }
    const o = offerOf(code);
    let next;
    if (o && o.ship) next = current.filter((c) => !(offerOf(c) || {}).ship).concat(code); // one shipping code
    else if (o) next = current.filter((c) => (offerOf(c) || {}).ship).concat(code); // one discount code, shipping codes stay
    else next = current.concat(code); // typed code: Shopify sorts out what combines
    setCodes(next, code);
  };

  const recoHtml = () => {
    if (!recos.length) return '';
    return `<section class="wpc__recos"><p class="wpc__recos-title">You may also like</p><ul role="list">${recos.slice(0, 3).map((p) => {
      const v = p.variants.find((x) => x.available) || p.variants[0];
      return `<li class="wpc__reco">
        <a href="${esc(p.url)}" class="wpc__reco-img"><img src="${esc(img(p.featured_image, 160))}" alt="" loading="lazy"></a>
        <a href="${esc(p.url)}" class="wpc__reco-name">${esc(p.title.split('|')[0].trim())}</a>
        <span class="wpc__reco-price">${money(p.price)}</span>
        <button type="button" class="wpc__reco-add" data-wpc-add="${v.id}">Add</button>
      </li>`;
    }).join('')}</ul></section>`;
  };

  const updateBubble = (count) => document.querySelectorAll('#cart-icon-bubble').forEach((icon) => {
    let b = icon.querySelector('.cart-count-bubble');
    if (!count) { if (b) b.remove(); return; }
    if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; icon.appendChild(b); }
    b.innerHTML = `${count < 100 ? `<span aria-hidden="true">${count}</span>` : ''}<span class="visually-hidden">${count} item${count > 1 ? 's' : ''}</span>`;
  });

  const render = () => {
    document.dispatchEvent(new CustomEvent('wp:cart-rendered', { detail: cart })); // checkout upsell (wp-upsell.js) prepares its offer
    const count = cart.item_count;
    $('[data-wpc-count]').textContent = count ? `(${count})` : '';
    updateBubble(count);
    const body = $('[data-wpc-body]');
    if (!count) {
      $('[data-wpc-progress]').hidden = true;
      $('[data-wpc-foot]').hidden = true;
      if (OFF) closeSheet(false);
      if (isAdding()) { body.innerHTML = skeleton; return; }
      body.innerHTML = emptyHtml();
      // favourites are fetched only once the drawer is actually open (not on every page view's warm-up render)
      if (root.classList.contains('is-open')) loadFavs();
      return;
    }
    const prog = progressHtml();
    $('[data-wpc-progress]').innerHTML = prog;
    $('[data-wpc-progress]').hidden = !prog;
    body.innerHTML = `<ul class="wpc__items" role="list">${groups().map(lineHtml).join('')}</ul>${recoHtml()}`;
    $('[data-wpc-foot]').innerHTML = footHtml();
    $('[data-wpc-foot]').hidden = false;
    if (OFF && OFF.open) renderSheet();
  };

  // empty cart: kit quiz + customer favourites (sections/wp-cart-favs.liquid: best sellers, at most 2 park designs)
  let favs = null;
  const favCard = (p) => `<li class="wpc__reco">
      <a href="/products/${esc(p.handle)}" class="wpc__reco-img"><img src="${esc(p.image)}" alt="" loading="lazy"></a>
      <a href="/products/${esc(p.handle)}" class="wpc__reco-name">${esc(p.title)}</a>
      <span class="wpc__reco-price">${money(p.price)}</span>
      <button type="button" class="wpc__reco-add" data-wpc-add="${p.variant}">Add</button>
    </li>`;
  const emptyHtml = () => `
    <div class="wpc__empty">
      <p class="wpc__empty-title">Your cart is empty</p>
      <a class="wpc__quiz" href="${esc(C.quizUrl)}">
        <span class="wpc__quiz-text"><b>Not sure where to start?</b><span>Answer a few quick questions and we'll match you with kits you'll love.</span></span>
        <span class="wpc__quiz-cta">Find your kit in 30 seconds &rarr;</span>
      </a>
      ${favs && favs.length ? `<section class="wpc__recos wpc__recos--empty"><p class="wpc__recos-title">Customer favorites</p><ul role="list">${favs.map(favCard).join('')}</ul></section>` : ''}
      <a href="${esc(C.emptyUrl)}" class="wpc__empty-all">Browse all kits &rarr;</a>
    </div>`;
  const loadFavs = async () => {
    if (favs) return;
    favs = [];
    try {
      const html = await nativeFetch('/collections/paint-by-numbers?sort_by=best-selling&section_id=wp-cart-favs').then((r) => r.text());
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-wpc-favs]');
      favs = JSON.parse(el ? el.textContent : '[]');
    } catch (e) { favs = []; }
    if (cart && !cart.item_count) render();
  };

  // recommendations for the first kit in the cart (kits only, not already in the cart)
  const loadRecos = async () => {
    const first = cart && cart.items.find((it) => C.kitTypes.includes(it.product_type));
    if (!first || recoFor === first.product_id) return;
    recoFor = first.product_id;
    try {
      const d = await nativeFetch(`/recommendations/products.json?product_id=${first.product_id}&limit=10&intent=related`).then((r) => r.json());
      const inCart = new Set(cart.items.map((it) => it.product_id));
      recos = (d.products || []).filter((p) => p.available && C.kitTypes.includes(p.type) && !inCart.has(p.id));
      render();
    } catch (e) { recos = []; }
  };

  // ----- events -----
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-wpc-close]')) { close(); return; }
    if (OFF) {
      if (e.target.closest('[data-wpc-offers]')) { openSheet(); return; }
      if (e.target.closest('[data-wpc-sheet-close]')) { closeSheet(); return; }
      const ap = e.target.closest('[data-wpc-offer-apply]');
      if (ap) { applyCode(ap.dataset.wpcOfferApply); return; }
      const rm = e.target.closest('[data-wpc-offer-remove]');
      if (rm) {
        const code = rm.dataset.wpcOfferRemove;
        setCodes((cart.discount_codes || []).map((d) => d.code).filter((c) => String(c).toUpperCase() !== code));
        return;
      }
      if (e.target.closest('[data-wpc-addkit]')) {
        // back to the cart, at the kit suggestions (or the kits collection when there are none)
        closeSheet(false);
        const rec = $('.wpc__recos');
        if (rec) rec.scrollIntoView({ behavior: 'smooth', block: 'start' }); else location.href = C.emptyUrl;
        return;
      }
    }
    const q = e.target.closest('[data-wpc-qty]');
    if (q) {
      const it = cart.items.find((x) => x.key === q.dataset.wpcQty);
      if (!it) return;
      const nq = Math.max(0, it.quantity + Number(q.dataset.step));
      const updates = { [it.key]: nq };
      if (nq === 0) { // removing a kit removes its bundle items and add-ons too
        const k = kaching(it);
        if (k && k.id) cart.items.forEach((x) => { const kk = kaching(x); if (kk && kk.id === k.id) updates[x.key] = 0; });
      }
      change(updates);
      return;
    }
    const r = e.target.closest('[data-wpc-remove]');
    if (r) {
      const updates = {};
      r.dataset.wpcRemove.split(',').forEach((k) => { updates[k] = 0; });
      change(updates);
      return;
    }
    const a = e.target.closest('[data-wpc-add]');
    if (a) {
      a.disabled = true;
      a.textContent = '…';
      nativeFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(a.dataset.wpcAdd), quantity: 1 }] }) })
        .then((r) => {
          if (!r.ok) { a.textContent = 'Sold out'; return null; }
          recos = recos.filter((p) => !p.variants.some((v) => String(v.id) === a.dataset.wpcAdd));
          return refresh(true);
        })
        .catch(() => { a.disabled = false; a.textContent = 'Add'; });
    }
  });
  root.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-wpc-code-form]');
    if (!f || !OFF) return;
    e.preventDefault();
    OFF.typed = f.elements.code.value;
    applyCode(OFF.typed);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
    if (OFF && OFF.open) closeSheet(); else close();
  });

  // header cart icon opens the drawer (window capture runs before the apps' document listeners)
  window.addEventListener('click', (e) => {
    const icon = e.target.closest('#cart-icon-bubble, a[href="/cart"]');
    if (!icon || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(!cart);
    refresh(false);
  }, true);

  // Dawn's product form: use this drawer instead of redirecting / Dawn's drawer
  const drawerApi = { getSectionsToRender: () => [], setActiveElement: () => {}, renderContents: () => refresh(true), classList: { contains: () => false, remove: () => {} } };
  document.addEventListener('submit', (e) => {
    const pf = e.target.closest('product-form');
    if (pf) pf.cart = drawerApi;
  }, true);
  const hookForms = () => document.querySelectorAll('product-form').forEach((pf) => { pf.cart = drawerApi; });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hookForms); else hookForms();
  window.addEventListener('load', hookForms);

  // any add to cart (fetch or XHR, from any app): open at once, fill in when it's done
  const isAdd = (url, method) => /\/cart\/add(\.js)?(\?|$)/.test(String(url)) && String(method || 'GET').toUpperCase() === 'POST';
  const isChange = (url, method) => /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(String(url)) && String(method || 'GET').toUpperCase() === 'POST';
  const ofetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const method = (init && init.method) || (input && input.method);
    const add = isAdd(url, method);
    const chg = !add && isChange(url, method) && root.classList.contains('is-open');
    if (add) { lastAdd = Date.now(); adding += 1; open(true); }
    const p = ofetch.apply(this, arguments);
    if (add) p.then(added, added);
    else if (chg) p.then(() => setTimeout(() => refresh(true), 60)).catch(() => refresh(true));
    return p;
  };
  const oopen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isAdd(url, method)) {
      lastAdd = Date.now();
      adding += 1;
      open(true);
      this.addEventListener('loadend', added);
    }
    return oopen.apply(this, arguments);
  };

  // Kaching Cart still listens to the cart icon and to adds; whenever it tries to open its (hidden) drawer,
  // open this one instead.
  new MutationObserver(() => {
    const h = document.documentElement;
    if (!h.classList.contains('kaching-body__cart-open')) return;
    h.classList.remove('kaching-body__cart-open');
    try { window.kachingCartApi && window.kachingCartApi.closeCart && window.kachingCartApi.closeCart(); } catch (e) { /* ignore */ }
    const now = Date.now();
    if (now - lastAdd < 6000 || now - lastClose < 3000) return; // late signal from an add we already handled
    if (!root.classList.contains('is-open')) { open(!cart); refresh(false); }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  window.wpCart = { open, close, refresh, fetch: nativeFetch, getCart: () => cart };
  // warm the cart so the first open is instant
  fetchCart().then((c) => { cart = c; render(); }).catch(() => {});
})();



